import { useEffect, useState } from "react";
import { apiClient } from "@/context/AuthContext";
import { AlertTriangle, Loader2, Mail, Shield, Trash2, UserPlus } from "lucide-react";

export default function MembersPanel({ assessmentId, isOwner, onToast }) {
  const [rows, setRows] = useState([]);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("co-consultant");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const { data } = await apiClient.get(`/assessments/${assessmentId}/members`);
      setRows(data || []);
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [assessmentId]);

  const invite = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await apiClient.post(`/assessments/${assessmentId}/invite`, { email, role });
      setEmail("");
      const sentMsg = { sent: `Davet e-postası gönderildi: ${email}`, failed: `Davet kaydedildi ama e-posta gönderilemedi: ${email}`, mocked: `Davet kaydedildi (e-posta gönderimi kapalı): ${email}` };
      onToast?.(sentMsg[data.email_status] || `Davet gönderildi: ${email}`);
      load();
    } catch (err) {
      setError(err?.response?.data?.detail || "Davet gönderilemedi");
    } finally { setLoading(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Üyeyi çıkarmak istiyor musunuz?")) return;
    try {
      await apiClient.delete(`/assessments/${assessmentId}/members/${id}`);
      load();
      onToast?.("Üye çıkarıldı");
    } catch (err) {
      onToast?.(err?.response?.data?.detail || "Çıkarma başarısız");
    }
  };

  return (
    <div data-testid="members-panel">
      {isOwner && (
        <form className="invite-form" onSubmit={invite}>
          <div className="row-fields">
            <label>E-posta <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="danisman@firma.com" data-testid="invite-email"/></label>
            <label>Rol
              <select value={role} onChange={(e) => setRole(e.target.value)} data-testid="invite-role">
                <option value="co-consultant">Birlikte danışman</option>
                <option value="reviewer">İnceleyici</option>
                <option value="owner">Bina sahibi</option>
              </select>
            </label>
            <button className="primary-btn" type="submit" disabled={loading} data-testid="invite-submit">
              {loading ? <Loader2 size={14} className="spin"/> : <UserPlus size={14}/>} Davet et
            </button>
          </div>
          {error && <div className="auth-error"><AlertTriangle size={14}/> {error}</div>}
        </form>
      )}
      <div className="member-rows" data-testid="member-rows">
        {!rows.length && <small className="evidence-empty">Henüz davet yok.</small>}
        {rows.map((m) => (
          <div key={m.id} className={`member-row ${m.status === "invited" ? "pending" : ""}`} data-testid={`member-${m.id}`}>
            <Mail size={14}/>
            <div className="member-main">
              <strong>{m.name || m.invite_email}</strong>
              <small>{m.role} · {m.status === "accepted" ? "Katıldı" : "Davet gönderildi"} · {(m.invited_at||"").slice(0,16).replace("T"," ")}</small>
              {m.email_status && <small className={`email-mock email-${m.email_status}`} data-testid={`member-email-status-${m.id}`}>{{ sent: "Davet e-postası gönderildi", failed: "Davet e-postası gönderilemedi", mocked: "Davet e-postası gönderilmedi (kapalı)" }[m.email_status]}</small>}
            </div>
            {m.status === "accepted" && <Shield size={13} title="Erişimi aktif"/>}
            {isOwner && <button className="icon-button" onClick={() => remove(m.id)} data-testid={`member-remove-${m.id}`}><Trash2 size={13}/></button>}
          </div>
        ))}
      </div>
    </div>
  );
}
